import locations from './locations'
import photos from './photos'
import pressLinks from './press_links'

export default {
  namespaced: true,
  state: {
    all: [],
    loading: false
  },
  modules: {
    locations,
    photos,
    pressLinks
  },
  getters: {
    all: state => state.all,
    find: state => state.all.find(organization => organization.id == Vue.$route.params.id),
    loading: state => state.loading
  },
  mutations: {
    startLoading(state) {
      state.loading = true
    },
    stopLoading(state) {
      state.loading = false
    },
    setAll(state, organizations) {
      state.all = organizations.sort((a, b) => {
        // Alphanumeric sort by Name
        const nameA = a.name.toUpperCase(); // ignore upper and lowercase
        const nameB = b.name.toUpperCase(); // ignore upper and lowercase

        if (nameA < nameB) return -1
        if (nameA > nameB) return  1
        return 0;
      })
      state.loading = false
    },
    set(state, organization) {
      state.all = state.all.filter(o => o.id != organization.id)
      state.all.push(organization)
    },
    remove(state, id) {
      state.all = state.all.filter(o => o.id != id)
    }
  },
  actions: {
    fetchAll({ commit }) {
      this.$authorize('list', 'Organization')

      commit('startLoading')
      return Vue.$http
        .get('admin/organizations')
        .then(response => commit('setAll', response.data), response => commit('stopLoading'))
    },
    fetch({ commit }, id) {
      this.$authorize('read', 'Organization')

      return Vue.$http.get(`admin/organizations/${id}`).then(response => commit('set', response.data))
    },
    create({ commit }, organization) {
      this.$authorize('create', 'Organization')

      return Vue.$http.post('admin/organizations', { organization }).then(
        response => {
          commit('set', response.data)
          return response.data
        },
        response => Object.assign(organization, response.data)
      )
    },
    update({ commit }, organization) {
      this.$authorize('edit', 'Organization')

      return Vue.$http
        .patch(`admin/organizations/${organization.id}`, { organization })
        .then(response => commit('set', response.data))
        .catch(error => commit('set', Object.assign(organization, error.response.data)))
    },
    destroy({ commit }, id) {
      this.$authorize('delete', 'Organization')

      return Vue.$http.delete(`admin/organizations/${id}`).then(response => commit('remove', id))
    }
  }
}
